<template>
  <div class="content-wrapper">
    <div class="workpage-content-wrapper">
      <breadcrumbs v-if="breadcrumbs" :items="breadcrumbs" />
      <div class="workpage-left-column">
        <LeftMenu v-if="menuItems" :items="menuItems" />

        <LeftBanner v-if="leftBanner" />
      </div>

      <div class="workpage-right-column">
        <div
          v-if="loading"
          class="progress-wrap d-flex align-center justify-center"
        >
          <v-progress-circular
            class="mb-12"
            :size="70"
            :width="5"
            indeterminate
          ></v-progress-circular>
        </div>

        <slot v-else></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: Array,
    menuItems: [Array, Object],
    leftBanner: Boolean,
    loading: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.progress-wrap {
  min-height: 700px;
}
</style>
